import React from "react";
import { useHusibuechContext } from "../../context/husibuechContext";
import MiddleBox from "../1_Boxes/MiddleBox";
import DeadlineAssignmentsList from "../4_DeadlineBox/DeadlineAssignmentsList";
import { createTeacherName } from "../../helpers/nameHelpers";
import BoxHeader from "../../components/1_Boxes/BoxHeader";

const RecentlyAdded = () => {
  const { isALeader, selectedCourse } = useHusibuechContext();

  return (
    <>
      <BoxHeader
        title={
          isALeader && selectedCourse
            ? `Kürzlich der ${selectedCourse?.name ? createTeacherName(selectedCourse.name) : "Klasse"} hinzugefügt`
            : "Neue Aufgaben"
        }
      />
      <MiddleBox>
        <DeadlineAssignmentsList
          type={"topSix"}
          // assignments={memoizedTopSix}
        />
      </MiddleBox>
    </>
  );
};

export default RecentlyAdded;
